<template>
  <div id="wayiHome">
    <!-- banner -->
      <section class="hearderBanner" v-if="headerBannerList.length > 0">
        <swiper ref="mySwiper" :options="swiperOptions" :style="{'height':bannerHeight + 'px'}" class="swiper-wrappe carousel">
          <swiper-slide class="swiper-slide" v-for="(b,i) in headerBannerList" :key="i">
            <img style="object-fit:fill" :src="b.img" alt="" @click="toBannerUrl(i)"/>
          </swiper-slide>
          <div v-show="headerBannerList && headerBannerList.length > 1" class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <!-- <div class="banner_content animate__animated animate__fadeInLeftBig" v-html="tenantConfig.bannerText"></div> -->
        <!-- <img class="shape-1 animate__animated animate__fadeInLeftBig" src="../assets/imgs/shapes/shape-1.png" alt="">
        <img class="shape-2 animate__animated animate__fadeInLeftBig" src="../assets/imgs/shapes/shape-2.png" alt="">
        <img class="shape-3" src="../assets/imgs/shapes/shape-3.png" alt="">
        <img class="shape-4" src="../assets/imgs/shapes/shape-4.png" alt=""> -->
        <!-- <a-row></a-row> -->
        <!-- <img class="shape-5 animate__animated animate__fadeInRightBig" src="../assets/imgs/shapes/shape-5.png" alt=""> -->
      </section>
      <!-- 图片1 -->
      <div v-if="tenantConfig.image_1_status == 1 && tenantConfig.home_code_img_1">
        <img :id="'home_code_img_1-' + index" style="width: 100%;height: auto;"  v-for="item,index in tenantConfig.home_code_img_1.split(',')" :src="item" :key="index" alt="">
      </div>
     <!-- 公司/机构简介 -->
      <member id="gsjgjs" v-if="tenantConfig.gsjgjs_status == 1" />
      <!-- 图片2 -->
      <div v-if="tenantConfig.image_2_status == 1 && tenantConfig.home_code_img_2">
        <img :id="'home_code_img_2-' + index" style="width: 100%;height: auto;"  v-for="item,index in tenantConfig.home_code_img_2.split(',')" :src="item" :key="index" alt="">
      </div>
     <!-- 课程列表 -->
     <curriculum id="kclb" :windowWidth="windowWidth" v-if="tenantConfig.course_status == 1" />
     <!-- 图片3 -->
      <div v-if="tenantConfig.image_3_status == 1 && tenantConfig.home_code_img_3">
        <img :id="'home_code_img_3-' + index" style="width: 100%;height: auto;"  v-for="item,index in tenantConfig.home_code_img_3.split(',')" :src="item" :key="index" alt="">
      </div>
    <!-- 联系方式 -->
      <section id="lxfs" v-if="tenantConfig.lxwm_status == 1" class="cta-1-section p-relative wow animate__animated  animate__fadeInDown " data-wow-delay=".5s" style="visibility: visible; animation-delay: 0.5s; animation-name: fadeInDown;">
        <div class="small-container">
            <a-row>
              <a-col :xs="24" :sm="24" :md="24" :lg="12" style="background-color: #fff;">
                  <img class="image" src="../assets/imgs/shapes/cta-1.jpg" alt="">
              </a-col>
              <a-col :xs="24" :sm="24" :md="24" :lg="12">
                <div class="content p-relative">
                      <img class="shape-1" src="../assets/imgs/shapes/shape-12.png"/>
                      <div class="icon-box">
                          <i class="iconfont" style="font-size: 24px;">&#xe681;</i>
                      </div>
                      <h3 class="mb-15" style="font-size: 36px;">{{ tenantConfig.contactText }}</h3>
                      <h5 style="font-size: 22px;"><a href="tel:2085550112">{{ tenantConfig.contactPhone }}</a></h5>
                    </div>
              </a-col>
            </a-row>
        </div>
      </section>
      <!-- 图片4 -->
      <div v-if="tenantConfig.image_4_status == 1 && tenantConfig.home_code_img_4">
        <img :id="'home_code_img_4-' + index" style="width: 100%;height: auto;"  v-for="item,index in tenantConfig.home_code_img_4.split(',')" :src="item" :key="index" alt="">
      </div>
    <!-- 我们的荣誉 -->
      <cert id="wmry" v-if="tenantConfig.wmry_status == 1" :windowWidth="windowWidth" />
      <!-- 图片5 -->
      <div v-if="tenantConfig.image_5_status == 1 && tenantConfig.home_code_img_5">
        <img :id="'home_code_img_5-' + index" style="width: 100%;height: auto;" v-for="item,index in tenantConfig.home_code_img_5.split(',')" :src="item" :key="index" alt="">
      </div>
    <!-- 师资介绍 -->
      <teachers id="szll" v-if="tenantConfig.szll_status == 1" :windowWidth="windowWidth"/>
    <!-- 九．竞赛精彩瞬间-学员风采 -->
      <competition v-if="tenantConfig.jcjs_status == 1" :windowWidth="windowWidth" />
      <!-- 图片6 -->
       <div v-if="tenantConfig.image_6_status == 1 && tenantConfig.home_code_img_6">
        <img :id="'home_code_img_6-' + index" style="width: 100%;height: auto;"  v-for="item,index in tenantConfig.home_code_img_6.split(',')" :src="item" :key="index" alt="">
      </div>
    <!-- 精选资讯 -->
      <Journalism id="jxzx" v-if="tenantConfig.jxzx_status == 1" />
    <Footer/>
  </div>
</template>
<script>
// import { getAction } from "@/api/manage";
import Footer from "@/components/footer/Footer";
import teachers from "../components/home/teachers.vue";
import competition from "../components/home/competition.vue";
import cert from "../components/home/cert.vue";
import curriculum from "../components/home/curriculum.vue";
import member from "../components/home/member.vue";
import Journalism from "../components/home/Journalism.vue";
import { WOW } from "wowjs";

export default {
  components: { Footer,teachers,competition,cert,curriculum,member,Journalism },
  data() {
    return {
      headerBannerList:[],
      swiperOptions: {
        speed: 800,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay:{
          delay: 2000,
          disableOnInteraction: false,
          pauseOnMouseEnter:true,
        },
        loop: true,
      },
      bannerLinksList: [],
      teacherBannerList:[],
      // 分辨率
      windowWidth: window.innerWidth,
      bannerHeight:734,
    };
  },
  watch: {
    windowWidth:{
      handler(newWidth) {
        console.log("宽度变化:", newWidth);
        this.bannerHeight = newWidth / 2.6
      },
      immediate:true
    }
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    }
  },
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo
    if (this.tenantConfig && this.tenantConfig.banner) {
      var headerBannerList = this.tenantConfig.banner.split(",");
      if(this.tenantConfig.bannerLinks){
        var bannerLinks = this.tenantConfig.bannerLinks.split("\n")
      }else{
        var bannerLinks = []
      }
      for (var i in headerBannerList) {
        var b = {};
        b.img = headerBannerList[i];
        if(bannerLinks.length>i){
          b.href = bannerLinks[i]
        }
        this.headerBannerList.push(b);
      }
    }
    if(this.tenantConfig.bannerLinks){
      this.bannerLinksList = this.tenantConfig.bannerLinks.split("\n");
    }
    if (this.tenantConfig && this.tenantConfig.banner2) {
      this.teacherBannerList = this.tenantConfig.banner2.split(",");
      let bannerList = this.tenantConfig.banner2.split(",");
      let bannerNameList = [];
      if(this.tenantConfig.bannerLinks2){
        bannerNameList = this.tenantConfig.bannerLinks2.split("\n");
      }
      
      for (let i = 0; i < bannerList.length; i++) {
        this.teacherBannerList[i] = {
          img: bannerList[i],
          name: bannerNameList.length <= (i-1) ? bannerNameList[i] : '',
        };
      }
    }
    // let timer = setTimeout(()=>{this.AIxStatus = true ,clearTimeout(timer)},5000)
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    // this.swiper = new Swiper(this.$refs.mySwiperKc, this.swiperKcOptions);
   this.$nextTick(()=>{
     const wow = new WOW({
     boxClass: 'wow',            
     animateClass: 'animated',   
     offset: 0,                 
     mobile: true,              
     live: true,                
     callback: function (box) {
         console.log('WOW: animating <' + box)
        // the callback is fired every time an animation is started
        // the argument that is passed in is the DOM node being animated
       },
       scrollContainer: null,     
     })
     wow.init()
   })
 
  },
  methods:{
    toBannerUrl(index){
      let urlType = this.bannerLinksList[index]
      if(urlType.indexOf('http') != -1){
        window.open(urlType,'_blank')
      }else{
        const targetId = this.bannerLinksList[index].split('#')[1];
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      }
    
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>
<style lang="less">
 @import '@/assets/less/wayiStyle.less';
 .swiper-wrappe .swiper-pagination-bullet-active{
    background: var(--primary-color) !important;
 }
.swiper-wrappe .swiper-pagination-bullet{
    background: #fff;
 }
</style>
<style lang='less' scoped>
#wayiHome{
  width: 100%;
  .hearderBanner{
    width: 100%;
    height: auto;
    // background: red;
    position: relative;
    overflow: hidden;
    .swiper-pagination{
      bottom: 20px;
      left: 0;
      right: 0;
      margin: auto;
      .swiper-pagination-bullet-active{
        
      }
    }
  }

}
</style>